<template>
  <div class="warpper">
    <div class="header">
      <div class="header_left">
        <el-avatar
          shape="square"
          size="small"
          :src="require('@/assets/recycling/index/SupervisionLogo.png')"
          icon="el-icon-user-solid"
        ></el-avatar>
        <div
          v-for="item in navTab"
          class="header_left_type"
          :class="choseKey == item.key ? 'chose_header_left_type' : ''"
          @click="goHomePage(item)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="header_right">
        <user-widget
          :username="username?.userDetail.username"
          userImg=""
          @home="handleHome"
          @profile="handleProfile"
          @logout="handleLogout"
        />
        <!--                <profile-modal-->
        <!--                  :visible="profileModalVisible"-->
        <!--                  :user="currentUser"-->
        <!--                  @edit-profile="editProfile"-->
        <!--                  @change-avatar="changeAvatar"-->
        <!--                  @updateVisible="profileModalVisible = false"-->
        <!--                />-->
      </div>
    </div>
    <router-view v-if="choseKey === 1" />
    <PriceIndex v-if="choseKey === 3" />
    <IndustrialEcology v-if="choseKey === 4" />
    <Apply v-if="choseKey === 5" />
    <bottom-url v-if="choseKey === 1 || choseKey === 5" />
    <el-backtop target=".warpper" :bottom="100"
      >1
      <div
        style="{
        height: 100%;
        width: 100%;
        background-color: #1989fa;
        border-radius: 50%;
        box-shadow: 0 0 6px rgba(0,0,0, .12);
        text-align: center;
        line-height: 40px;
        color: #ffffff;
      }"
      >
        <i style="font-size: 24px" class="el-icon-caret-top"></i>
      </div>
    </el-backtop>
  </div>
</template>

<script>
import BottomUrl from '@/components/bottomUrl/bottomUrl.vue';
import { logoutPlatform } from '@/API/login/login';
import UserWidget from '@/views/Regulatory/HOME/component/UserWidget.vue';
import ProfileModal from '@/views/Regulatory/HOME/component/ProfileModal.vue';
import PriceIndex from '@/views/PriceIndex/index.vue';
import IndustrialEcology from '@/views/IndustrialEcology/index.vue';
import Apply from '@/views/apply/apply.vue';

export default {
  name: 'index',
  components: {
    ProfileModal,
    UserWidget,
    BottomUrl,
    PriceIndex,
    IndustrialEcology,
    Apply,
  },
  data() {
    return {
      navTab: [
        {
          name: '安全监管',
          path: '/supervisionHomepage/Punishment',
          key: 1,
        },
        {
          name: '产业地图',
          path: '/recyclingOutlets',
          key: 2,
        },
        {
          name: '价格指数',
          path: '/Home/priceIndex?to=1',
          key: 3,
        },
        {
          name: '企业名录',
          path: '',
          key: 4,
        },
        {
          name: '补贴申报',
          path: '',
          key: 5,
        },
      ],
      choseKey: 1,
      username: JSON.parse(localStorage.getItem('ordinaryUser')) || null,
      profileModalVisible: false,
      currentUser: {
        username:
          JSON.parse(localStorage.getItem('supervisionUser'))?.userDetail
            .username || null,
        avatar: '',
        phone: '138****8000',
        email: '5100**@example.com',
        registerTime: '2025-05-10 08:30:00',
      },
    };
  },
  methods: {
    loginOut(where) {
      logoutPlatform().then((res) => {
        if (res.code === 200) {
          this.$message.success('监管用户退出登录成功！');
          this.clearMessage(where);
        }
      });
    },
    handleHome() {
      // this.loginOut();
      this.$router.push('/Home/pages');
    },
    handleProfile() {
      this.profileModalVisible = true;
    },
    handleLogout() {
      this.loginOut('SignIn');
    },
    editProfile() {
      console.log('跳转到编辑资料页面');
      // this.$router.push('/profile/edit')
    },
    changeAvatar() {
      console.log('打开更换头像对话框');
      // 实现头像上传逻辑
    },
    // 退出清空缓存信息
    clearMessage(where) {
      this.$store.commit('changeSupervisionUser', '');
      this.$store.commit('SET_SupervisionLoggedIn', false);
      localStorage.removeItem('supervisionToken');
      localStorage.removeItem('supervisionUser');
      localStorage.removeItem('supervisionLoggedIn');
      if (where === 'SignIn') {
        this.$router.push('/SignIn');
      } else {
        this.$router.push('/Home');
      }
    },

    goHomePage(item) {
      this.choseKey = item.key;
      if (item.key === 2) {
        this.$router.push(item.path);
      }
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and (max-width: 768px) {
  .header {
    height: 35px !important;
    padding: 0 10px !important;
    .chose_header_left_type {
      font-size: 14px !important;
    }
  }

  .user-widget {
    width: 100% !important;
  }
  /deep/.user-name {
    max-width: 100% !important;
    font-size: 14px !important;
  }
}

.warpper {
  background: rgb(239, 239, 239);
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  overflow-y: auto;

  .header {
    padding: 0 250px;
    height: 48px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff;
    margin-bottom: 12px;

    .header_left {
      display: flex;
      justify-content: center;
      align-items: center;

      .header_left_type {
        margin-left: 16px;
        font-size: 16px;
        font-weight: 700;
        color: #656565;
        cursor: pointer;
      }

      .chose_header_left_type {
        color: rgb(40, 153, 254);
      }
    }

    .header_right {
      display: flex;
      justify-content: center;
      align-items: center;

      .header_right_type {
        margin-left: 5px;
        font-size: 14px;
        color: rgb(34, 34, 34);
      }
    }

    .header_right_close {
      margin-left: 10px;
      width: 2.08333vw;
      height: 2.08333vw;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: rgba(143, 143, 143, 0.76);
      font-size: 0.9375vw;
      cursor: pointer;
    }

    .header_right_close:hover {
      color: #ff6b6b;
    }
  }
}
</style>
